/**
 * API functions for AgentChat component
 * Wraps the agentApi from AI UI's services
 */

import { agentApi } from '../../services/api';

/**
 * List main assistant sessions - calls dedicated Main Assistant endpoint
 */
export const listMainAssistantSessions = async (params = {}) => {
    // Use the dedicated Main Assistant sessions endpoint for proper filtering
    const response = await agentApi.getMainAssistantSessions(
        params.archived,
        params.page || 1,
        params.page_size || 20
    );
    return response;
};

/**
 * List sessions for a specific agent
 */
export const listAgentSessions = async (agentId, params = {}) => {
    const response = await agentApi.getSessions(
        agentId,
        params.is_active !== false, // default to active
        params.page || 1,
        params.page_size || 20
    );
    return response;
};

/**
 * Archive a main assistant session
 */
export const archiveMainAssistantSession = async (sessionId) => {
    return agentApi.archiveSession(sessionId);
};

/**
 * Unarchive a main assistant session
 */
export const unarchiveMainAssistantSession = async (sessionId) => {
    return agentApi.unarchiveSession(sessionId);
};

/**
 * Delete a main assistant session
 */
export const deleteMainAssistantSession = async (sessionId) => {
    return agentApi.deleteSession(sessionId);
};

/**
 * Fork a conversation session
 */
export const forkAgentSession = async (sessionId, payload = {}) => {
    return agentApi.forkSession(sessionId, payload);
};

/**
 * List available agents
 */
export const listUserAgents = async (params = {}) => {
    const response = await agentApi.list(
        1, // page
        100, // page_size
        { is_active: params.is_active }
    );
    return response;
};
